export default {
  buttons: {
    signup: 'Registar',
    login: 'Iniciar sessão',
  },
};
